module.exports = __webpack_public_path__ + "media/movement-paper.cbc81b92.wav";